import React, { useEffect } from "react";
import Common from "./Common";

const Footer = () => {
  useEffect(() => {
    const scripts = [
      // jQuery
      "/assets/js/jquery.min.js",

      // Bootstrap
      "/assets/js/bootstrap.bundle.min.js",

      // Vendor JS
      "/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js",
      "/assets/vendor/overlay-scroll/custom-scrollbar.js",
      "/assets/vendor/toastify/toastify.js",
      "/assets/vendor/toastify/custom.js",

      // Moment
      "/assets/js/moment.min.js",

      // Date range
      "/assets/vendor/daterange/daterange.js",
      "/assets/vendor/daterange/custom-daterange.js",

      // Chart.js
      "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.min.js",

      // Elite Theme
      "/assets/js/elite.js?v=57",

      // Custom JS
      "/assets/js/custom.js",
    ];

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        // Don't load the same script twice
        const existingScript = document.querySelector(
          `script[data-src="${src}"]`
        );

        if (existingScript) {
          resolve();
          return;
        }

        const script = document.createElement("script");

        script.src = src;
        script.async = false;
        script.setAttribute("data-src", src);

        script.onload = () => {
          console.log("Loaded:", src);
          resolve();
        };

        script.onerror = () => {
          console.error("Failed to load:", src);
          reject(new Error(`Failed to load ${src}`));
        };

        document.body.appendChild(script);
      });
    };

    const loadAllScripts = async () => {
      try {
        for (const src of scripts) {
          await loadScript(src);
        }

        console.log("All footer scripts loaded successfully");
      } catch (error) {
        console.error("Error loading footer scripts:", error);
      }
    };

    loadAllScripts();
  }, []);

  return (
    <>
      <Common />
    </>
  );
};

export default Footer;
